const api_url = process.env.REACT_APP_API_URL;

export const apiUrls = {
    root: api_url,
    signUp: `${api_url}/api/v1/users`,
    cities: `${api_url}/api/v1/cities`,
    languages: `${api_url}/api/v1/languages`,
    getOrPostImages: `${api_url}/api/v1/users/{user_id}/user_images`,
    getOrDeleteImage: `${api_url}/api/v1/users/{user_id}/user_images/{image_id}`,
    countries: `${api_url}/api/v1/countries`,
    loginOrRefresh: `${api_url}/oauth/token`,
    logout: `${api_url}/oauth/revoke`,
    users: `${api_url}/api/v1/users/{user_id}`,
    experiences: `${api_url}/api/v1/users/{user_id}/experiences/`,
    modifyExperiences: `${api_url}/api/v1/users/{user_id}/experiences/{exp_id}`,
    contactDetails: `${api_url}/api/v1/users/{user_id}/contact_details`,
    socialPlatforms: `${api_url}/api/v1/social_platforms`,
    interests: `${api_url}/api/v1/users/{user_id}/other_interests`,
    socialLinks: `${api_url}/api/v1/users/{user_id}/social_links`,
    userLanguages: `${api_url}/api/v1/users/{user_id}/user_languages`,
    userLocation: `${api_url}/api/v1/users/{user_id}/user_location`,
    deleteUserLanguages: `${api_url}/api/v1/users/{user_id}/user_languages/{user_language_id}`,
    physicalDetails: `${api_url}/api/v1/physical_details`,
    profileStrength: `${api_url}/api/v1/users/{user_id}/profile_progress`,
    profile: `${api_url}/api/v1/users/{user_id}/user_profile`,
    agency: `${api_url}/api/v1/users/{user_id}/agency`,
    updateProfile: `${api_url}/api/v1/users/{user_id}`,
    forgotPassword: `${api_url}/api/v1/password/forgot`,
    resetPassword: `${api_url}/api/v1/password/reset`,
    usersWithOutUserId: `${api_url}/api/v1/users`,
    agencyCategories: `${api_url}/api/v1/users/{user_id}/agency_categories`,
    jobPurpose: `${api_url}/api/v1/job_purposes`,
    currencies: `${api_url}/api/v1/currencies`,
    getAgencyDetails: `${api_url}/api/v1/agencies/{agency_id}`,
    createJob: `${api_url}/api/v1/agencies/{agency_id}/jobs`,
    updateJob: `${api_url}/api/v1/agencies/{agency_id}/jobs/{job_id}`,
    getJobById: `${api_url}/api/v1/agencies/{agency_id}/jobs/{job_id}`,
    plans: `${api_url}/api/v1/subscriptions/plan_list`,
    checkout: `${api_url}/api/v1/subscriptions`,
    subscriptionList: `${api_url}/api/v1/users/:user_id/subscription_details`,
    billing: `${api_url}/api/v1/subscriptions/billing?user_id={user_id} `,
    accountDetails: `${api_url}/api/v1/users/:id`,
    deleteSubscription: `${api_url}/api/v1/subscriptions/cancel/{{subscription_id}}`,
    deleteAccount: `${api_url}/api/v1/users/user_id/delete_account`,
    changePassword: `${api_url}/api/v1/users/{user_id}/change_password`,
    getJobsListing: `${api_url}/api/v1/jobs`,
    likeJob: `${api_url}/api/v1/likes`,
    getLikeJob: `${api_url}/api/v1/likes?user_id={user_id}`,
    applyJob: `${api_url}/api/v1/jobs/{{job_id}}/apply`,
    followAgent: `/api/v1/agencies/{agency_id}/follow?user_id={user_id}`,
    unFollowAgent: `/api/v1/agencies/{agency_id}/unfollow?user_id={user_id}`,
};
